module.exports = __webpack_public_path__ + "static/media/Artboard13.539ad989.png";